import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ProjectTestStage } from '../models/project.model';

@Injectable({ providedIn: 'root' })
export class ProjectTestStageService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  list(projectId: string): Observable<ProjectTestStage[]> {
    return this.http.get<ProjectTestStage[]>(`${this.base}/${encodeURIComponent(projectId)}/test-stages`);
  }
}
